// src/services/pos/puntoDeVentaService.ts
import { axiosInstance } from '../axiosConfig';
import { handleRequestWithAuth } from '../refreshService';
import { TipoPago } from '../tiposPagoService';

const API_URL = 'puntos-de-venta/';

export interface PuntoDeVenta {
    id: number;
    nombre: string;
    ubicacion: string;
    estado: 'activo' | 'inactivo' | 'mantenimiento';
    usuario_actual: number | null;
    usuario_actual_nombre: string | null;
    responsables: number[];
    responsables_info: Array<{ id: number; nombre: string; email: string }>;
    saldo_actual: number;
    fecha_creacion: string;
    ultimo_cierre: string | null;       
    sesion_activa_id: number | null;     
    nivel_usuario_clientes?: number | null;
    canal_facturacion?: number | null;
    codigo_orden_config: number | null;
    codigo_pago_config: number | null;
    codigo_sesion_pos_config: number | null;
    puede_reporte_pdf: boolean;
    puede_reporte_csv: boolean;
    puede_reporte_excel: boolean;
    sucursal: number;
    sucursal_info: {
        id: number;
        nombre: string;
        codigo: string;
    } | null;
    // NUEVOS CAMPOS DE CAFETERÍA / CITAS
    habilitar_citas: boolean;
    habilitar_cafeteria: boolean;
    // Tipos de pago permitidos
    tipos_pago_permitidos: number[];
    tipos_pago_permitidos_info?: TipoPago[];
}

// Obtener todos los puntos de venta
export const fetchPuntosDeVenta = async (sucursalId?: number): Promise<PuntoDeVenta[]> => {
    return handleRequestWithAuth(async () => {
        const params = sucursalId ? { sucursal_id: sucursalId } : {};
        const response = await axiosInstance.get(API_URL, { params });
        return response.data;
    });
};

// Obtener un punto de venta por ID
export const fetchPuntoDeVenta = async (id: number): Promise<PuntoDeVenta> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}${id}/`);
        return response.data;
    });
};

// Crear un nuevo punto de venta
export const createPuntoDeVenta = async (data: {
    nombre: string;
    ubicacion: string;
    estado: 'activo' | 'inactivo' | 'mantenimiento';
    sucursal: number;
    usuario_actual?: number | null;
    responsables?: number[];
    codigo_sesion_pos_config?: number | null;
    nivel_usuario_clientes?: number | null;
    canal_facturacion?: number | null;
    codigo_orden_config?: number | null;
    codigo_pago_config?: number | null;
    puede_reporte_pdf?: boolean;
    puede_reporte_csv?: boolean;
    puede_reporte_excel?: boolean;
    tipos_pago_permitidos?: number[];
    // NUEVOS
    habilitar_citas?: boolean;
    habilitar_cafeteria?: boolean;
}): Promise<PuntoDeVenta> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.post(API_URL, data);
        return response.data;
    });
};

// Actualizar un punto de venta existente
export const updatePuntoDeVenta = async (
    id: number,
    data: {
        nombre?: string;
        ubicacion?: string;
        estado?: 'activo' | 'inactivo' | 'mantenimiento';
        sucursal?: number;
        responsables?: number[];
        saldo_actual?: number;
        codigo_sesion_pos_config?: number | null;
        nivel_usuario_clientes?: number | null;
    canal_facturacion?: number | null;
    codigo_orden_config?: number | null;
        codigo_pago_config?: number | null;
        puede_reporte_pdf?: boolean;
        puede_reporte_csv?: boolean;
        puede_reporte_excel?: boolean;
        tipos_pago_permitidos?: number[];
        // NUEVOS
        habilitar_citas?: boolean;
        habilitar_cafeteria?: boolean;
    }
): Promise<PuntoDeVenta> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.patch(`${API_URL}${id}/`, data);
        return response.data;
    });
};

// Eliminar un punto de venta
export const deletePuntoDeVenta = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};

// Obtener puntos de venta por sucursal
export const fetchPuntosDeVentaPorSucursal = async (sucursalId: number): Promise<PuntoDeVenta[]> => {
    return fetchPuntosDeVenta(sucursalId);
};

// Actualizar tipos de pago permitidos para un POS
export const updateTiposPagoPos = async (posId: number, tiposPagoIds: number[]): Promise<PuntoDeVenta> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.patch(`${API_URL}${posId}/`, {
            tipos_pago_permitidos: tiposPagoIds
        });
        return response.data;
    });
};


